import { Modal } from "react-bootstrap";
import { useTranslation } from 'react-i18next';
import { LeadsModalModeEnum } from '../../../api/models/Enums';
import AssignSale from './ModalBody/LeadReAssign';
import LeadDetails from '../modal/ModalBody/LeadDetails';
import LeadCreate from '../modal/ModalBody/LeadCreate';
import LeadWizard from '../modal/ModalBody/LeadWizard';
import LeadPhoneCallMessage from '../modal/ModalBody/LeadPhoneCallMessage';
import useLeadsStore from '../../../store/LeadsStore'
import useModalStore from '../../../store/ModalStore';
import LeadUnqualified from './ModalBody/LeadUnqualified';
import { useSearchParams } from "react-router-dom";

const ModalTitle = ({ mode }: { mode: LeadsModalModeEnum }) => {
  const { t } = useTranslation();
  switch (mode) {
    case LeadsModalModeEnum.CREATE_NEW_LEAD:
      return <Modal.Title className='display-6'>{t("create_new_lead")}</Modal.Title>;
    case LeadsModalModeEnum.ASSIGN_SALE:
      return <Modal.Title className='display-6'>{t("assign_lead_to_sales")}</Modal.Title>;
    case LeadsModalModeEnum.DETAILS:
      return <Modal.Title className='display-6'>{t("lead_details")}</Modal.Title>;
    case LeadsModalModeEnum.PHONE_CALL_WITH_REPLY:
      return <Modal.Title className='display-6'>{t("call_with_reply")}</Modal.Title>;
    case LeadsModalModeEnum.PHONE_CALL_NO_REPLY:
      return <Modal.Title className='display-6'>{t("call_no_reply")}</Modal.Title>;
    case LeadsModalModeEnum.QUALIFIED:
      return <Modal.Title className='display-6'>{t("convert_lead")}</Modal.Title>;
    case LeadsModalModeEnum.UNQUALIFIED:
      return <Modal.Title className='display-6'>{t("choose_a_motivation")}</Modal.Title>;
    default:
      return <></>;
  }
};

const ModalBody = ({ mode }: { mode: LeadsModalModeEnum }) => {
  const { t } = useTranslation();
  switch (mode) {
    case LeadsModalModeEnum.CREATE_NEW_LEAD:
      return <LeadCreate />
    case LeadsModalModeEnum.ASSIGN_SALE:
      return <AssignSale />
    case LeadsModalModeEnum.DETAILS:
      return <LeadDetails />
    case LeadsModalModeEnum.PHONE_CALL_WITH_REPLY:
    case LeadsModalModeEnum.PHONE_CALL_NO_REPLY:
      return <LeadPhoneCallMessage />
    case LeadsModalModeEnum.QUALIFIED:
      return <LeadWizard />
    case LeadsModalModeEnum.UNQUALIFIED:
      return <LeadUnqualified />
    default:
      return <div>{t("not_data_available")}</div>;
  }
};

const ModalLeads = () => {
  const modalState = useModalStore((state) => state.modalState);
  const openModal = useModalStore((state) => state.openModal);
  const closeModal = useModalStore((state) => state.closeModal);
  const cleanLeadWizardData = useLeadsStore((state) => state.cleanLeadWizardData);
  const cleanActiveLead = useLeadsStore((state) => state.cleanActiveLead);
  const isOpen = modalState.isOpen;
  const mode = modalState.mode;
  const [, setSearchParams] = useSearchParams();

  const getModalSize = (mode: LeadsModalModeEnum) => {
    switch (mode) {
      case LeadsModalModeEnum.DETAILS:
        return "xl";
      case LeadsModalModeEnum.CREATE_NEW_LEAD:
        return "lg";
      case LeadsModalModeEnum.ASSIGN_SALE:
        return "lg";
      case LeadsModalModeEnum.QUALIFIED:
        return "xl";
      case LeadsModalModeEnum.UNQUALIFIED:
        return "lg";
      default:
        return undefined;
    }
  };

  const handleCloseModal = () => {
    closeModal()
    setSearchParams({}, { replace: true })

    if ([LeadsModalModeEnum.QUALIFIED, LeadsModalModeEnum.UNQUALIFIED].includes(mode)) {
      openModal(LeadsModalModeEnum.DETAILS)
      cleanLeadWizardData()
    } else {
      if (![LeadsModalModeEnum.PHONE_CALL_WITH_REPLY, LeadsModalModeEnum.PHONE_CALL_NO_REPLY].includes(mode)) {
        cleanActiveLead()
      }
    }
  }


  return (
    <Modal
      show={isOpen}
      onHide={handleCloseModal}
      size={getModalSize(mode)}
    >
      <Modal.Header closeButton >
        <ModalTitle mode={mode} />
      </Modal.Header>
      <Modal.Body>
        <ModalBody mode={mode} />
      </Modal.Body>
    </Modal>
  );
};

export default ModalLeads;
